import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';

// Ionic Native
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';

// Angular Material
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';

// Interceptors
import { JwtInterceptorService } from './interceptors/jwt-interceptor/jwt-interceptor.service';
import { ErrorInterceptorService } from './interceptors/error-interceptor/error-interceptor.service';

// Error Handlers
import { JsErrorHandler } from './jsErrorHandler';
import { ConfirmExportNotesDialogComponent } from './dialogs/confirm-export-notes-dialog/confirm-export-notes-dialog/confirm-export-notes-dialog.component';

import { FingerprintAIO } from '@awesome-cordova-plugins/fingerprint-aio/ngx';

import { SwiperModule } from 'swiper/angular';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, ConfirmExportNotesDialogComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SwiperModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    MatDialogModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
    { provide: ErrorHandler, useClass: JsErrorHandler },
    Device,
    ScreenOrientation,
    FingerprintAIO,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
